import { createSelector } from 'reselect';
import { FLAG_KEYS } from 'lib/constants';
import { getLaunchDarklyFlags } from './getLaunchDarklyFlags';
import { getIsJobLaborTrackingEnabled } from './getIsJobLaborTrackingEnabled';

const getBarcodeScanningEnabled = createSelector(
  [getLaunchDarklyFlags, getIsJobLaborTrackingEnabled],
  (flags, isJobLaborTrackingEnabled) => {
    const isErpEnabled = isJobLaborTrackingEnabled;
    const featureFlagEnabled =
      flags?.[FLAG_KEYS.BARCODE_SCANNING_ENABLED] || false;

    return featureFlagEnabled && isErpEnabled;
  }
);

export { getBarcodeScanningEnabled };
